<aya-new-version-message *ayaVersionChecker></aya-new-version-message>
<div class="app-container">
    <nova-nav-menu class="flex-display">
        <nova-menu-item name="welcome" defaultItem="home" title="Home" icon="home"></nova-menu-item>
        <nova-menu-item name="_recruiting" defaultItem="candidates-search" title="Find a Candidate" icon="search"
                        dataCy="findCandidateMenuItem">
        </nova-menu-item>

        <nova-menu-item name="admin" title="Admin" icon="person">
            <nova-menu-item name="users" title="Users"></nova-menu-item>
            <nova-menu-item name="security-groups" title="Security Groups"></nova-menu-item>
            <nova-menu-item name="timecards" title="Time Cards"></nova-menu-item>
            <nova-menu-item name="cloneuser" title="Clone Aya Employee"></nova-menu-item>
            <nova-menu-item name="grid-demo" title="Grid Component Demo"></nova-menu-item>
            <nova-menu-item name="controls-demo" title="Shared Controls Demo"></nova-menu-item>
            <nova-menu-item name="integration-lookup-tables" title="Integration Lookup Tables"></nova-menu-item>
            <nova-menu-item name="team-manager" title="Team Manager"></nova-menu-item>
            <nova-menu-item name="compliance-mappings" title="Compliance Mappings"></nova-menu-item>
            <nova-menu-item name="expense-caps" title="Expense Caps Configuration"></nova-menu-item>
            <nova-menu-item name="integration-managev2" title="Integration Manage V2"></nova-menu-item>
            <nova-menu-item name="integration-mapping" title="Integration Mappings"></nova-menu-item>
            <nova-menu-item name="integration-dashboard" title="Integration Dashboard"></nova-menu-item>
            <nova-menu-item name="professions-specialties-management"
                            title="Professions & Specialties"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="compliance" title="Compliance" icon="check_circle" dataCy="complianceMenuItem">
            <nova-menu-item name="dashboard" path="contracts" title="PRE & WOR List"
                            dataCy="preWorSubMenuItem"></nova-menu-item>
            <nova-menu-item name="validation-queue" title="Validation Queue"
                            dataCy="validationQueueSubMenuItem"></nova-menu-item>
            <nova-menu-item name="licensure-new" title="State Licensure"></nova-menu-item>
            <nova-menu-item name="enotify-queue" title="Nursys e-Notify Queue"></nova-menu-item>
            <nova-menu-item name="ComplianceMatchGroupView" path="groups" title="Groups"></nova-menu-item>
            <nova-menu-item name="doc-posting" title="Doc Posting"></nova-menu-item>
            <nova-menu-item title="Posted Docs" name="posted-docs">
                <nova-menu-item name="pending-review-grouped" title="Pending QM Review"
                                path="posted-docs-grouped-qm-review" [queryParams]="{ statusCode: 1 }"></nova-menu-item>
                <nova-menu-item name="pending-upload-grouped" title="Pending Upload" path="posted-docs-grouped-upload"
                                [queryParams]="{ statusCode: 4 }"></nova-menu-item>
                <nova-menu-item *ifLdFeature="flags.MissingMetadataQueue" name="pending-review-grouped"
                                title="Missing Metadata Queue" path="missing-metadata-queue"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="doc-admin" title="Requirements" path="requirements-admin"></nova-menu-item>
            <nova-menu-item name="automatch-rule-conflicts" path="automatch-rule-conflicts/unresolved" title="Unresolved Rule Conflicts" *ifLdFeature="flags.EnableAutomatchUnresolvedConflict"></nova-menu-item>
            <nova-menu-item name="shipping-requests" title="Shipping Requests"></nova-menu-item>
            <!-- These are called Health Requests in the code-->
            <nova-menu-item name="health-requests" path="compliance-requests"
                            title="H&DS Requests"  *ifLdFeature="flags.hdsRefactoring;enabled:false"></nova-menu-item>

            <nova-menu-item name="health-requests" path="compliance-requests-hds" *ifLdFeature="flags.hdsRefactoring"
                            title="H&DS Requests">
                <nova-menu-item name="health-requests" title="Certifications"
                            path="compliance-requests-certifications" [queryParams]="{ ticketType: 4 }"></nova-menu-item>
                <nova-menu-item name="health-requests" title="Compliance Requests"
                            path="compliance-requests-new"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="can-set-ds-codes" path="ds-admin"
                            title="Drug Screen Admin" data-qa-id="dsAdminMenuItem"></nova-menu-item>
            <nova-menu-item *ifLdFeature="flags.SterlingBackgroundChecks" name="access-background-check" path="background-checks"
                            title="Background Checks" data-qa-id="backgroundChecksMenuItem"></nova-menu-item>
            <nova-menu-item name="facilities" path="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="qmassociations" title="QM Associations"
                            dataCy="qmAssociationsSubMenuItem"></nova-menu-item>
            <nova-menu-item name="doc-admin" title="States" path="states"
                            dataCy="statesRequirementSubMenuItem"></nova-menu-item>
            <nova-menu-item name="vendor-admin-view" path="vendor-admin" title="Vendor Admin"></nova-menu-item>
        </nova-menu-item>
        <nova-menu-item name="recruiting" title="Travel Recruiting" icon="how_to_reg" dataCy="travelRecruitingMenuItem"
                        [showDealAlert]="displayDealAlert">
            <nova-menu-item name="texting" title="Texting">
                <nova-menu-item name="text-responses" title="Texting Responses"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="atm" title="ATM"></nova-menu-item>
            <nova-menu-item name="rec-dashboard" title="Dashboard"></nova-menu-item>
            <nova-menu-item name="candidate-followups" title="Follow-Ups"></nova-menu-item>
            <nova-menu-item name="dashboard" path="candidates" title="Candidates"
                            dataCy="travelRecruitingCandidatesMenuItem">
                <nova-menu-item name="live-nurses-new" path="live-nurses-new" title="Live List"></nova-menu-item>
                <nova-menu-item name="prestart-candidates" path="prestart-candidates" title="Pre-Start Candidates">
                </nova-menu-item>
                <nova-menu-item name="search-all-candidates" path="search-all-candidates" title="Search All Candidates">
                </nova-menu-item>
                <nova-menu-item name="working-candidates" path="working-candidates" title="Working Candidates">
                </nova-menu-item>
            </nova-menu-item>

            <nova-menu-item name="contracts" title="Contracts"></nova-menu-item>
            <nova-menu-item name="resume-search" path="resume-search" title="Search for Resumes"></nova-menu-item>
            <nova-menu-item name="margins" title="Margins">
                <nova-menu-item *ifLdFeature="flags.RecruitingGsaLookup" name="per-diems-lookup" path="per-diems/lookup" title="GSA Lookup"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="facilities" path="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="jobs" title="Jobs"></nova-menu-item>
            <nova-menu-item name="contract-requests-new" title="Contract Requests"></nova-menu-item>
            <nova-menu-item name="deals" title="Deals" [showDealAlert]="displayDealAlert"></nova-menu-item>

        </nova-menu-item>

        <nova-menu-item name="locums" title="Locums" icon="stethoscope" *ngIf="shiftManagementFacilitySchedule">
            <nova-menu-item name="shift-management" title="Shift Management"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="travelx" title="Ticketing" icon="flag">
            <nova-menu-item name="tickets" title="Tickets"></nova-menu-item>
            <nova-menu-item name="tasks" title="Tasks"></nova-menu-item>
            <nova-menu-item name="email-settings" title="Email Settings"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="travel-contracts" title="Travel Contracts" icon="how_to_reg">
            <nova-menu-item name="admin" title="Admin"></nova-menu-item>
            <nova-menu-item name="contract-queue" title="Contract Queue"></nova-menu-item>
            <nova-menu-item name="subcontractor-queue" title="Subcontractor Queue"></nova-menu-item>
            <nova-menu-item name="contracts" title="Search Contracts"></nova-menu-item>
            <nova-menu-item name="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="candidates" title="Candidates"></nova-menu-item>
            <nova-menu-item name="margins" title="Margins">
                <nova-menu-item *ifLdFeature="flags.GsaAdminTool" name="per-diems-admin" title="GSA Admin Tool"></nova-menu-item>
                <nova-menu-item *ifLdFeature="flags.TravelContractsGsaLookup" name="per-diems-lookup" path="per-diems/lookup" title="GSA Lookup"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item *ifLdFeature="flags.MinimumWageAdminTool" name="min-wage-admin" title="Min Wage Admin Tool"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="travelxnew" title="TravelX" icon="face">
            <nova-menu-item name="candidates" path="candidates" title="Contracts">
                <nova-menu-item name="workforce-disruption"
                                path="workforce-disruption" title="WFD Booked Candidates">
                </nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="candidates" path="candidates-search" title="Candidates"></nova-menu-item>
            <nova-menu-item name="orientations" path="orientations" title="Orientations"></nova-menu-item>
            <nova-menu-item name="live-nurses" path="live-nurses" title="Live Nurses (new)"></nova-menu-item>
            <nova-menu-item name="tickets" title="Tickets"></nova-menu-item>
            <nova-menu-item name="tasks" title="Tasks"></nova-menu-item>
            <nova-menu-item name="email-settings" title="Email Settings"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="payroll" title="Payroll" icon="monetization_on">
            <nova-menu-item name="candidates" title="Candidates"></nova-menu-item>
            <nova-menu-item name="timecards-new" title="Time Cards"></nova-menu-item>
            <nova-menu-item name="timecard-shifts" title="Time Card Shifts"></nova-menu-item>
            <nova-menu-item name="perdiem-payrates_holidays" path="payrates-holidays" title="Aya Holidays">
            </nova-menu-item>
            <nova-menu-item name="perdiem-payrates_overtime" path="payrates-overtime" title="State Overtime">
            </nova-menu-item>
            <nova-menu-item name="facility-profiles" title="Facility Profiles"></nova-menu-item>
            <nova-menu-item name="contracts" title="Contracts"></nova-menu-item>
            <nova-menu-item name="timecard-import-queue" title="Timecard Import Queue"></nova-menu-item>
            <nova-menu-item name="timekeepingsystems" title="Timekeeping Systems"></nova-menu-item>
            <nova-menu-item name="reimbursements" title="Reimbursements"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="billing" title="Billing" icon="receipt">
            <nova-menu-item name="invoices" title="Invoices"></nova-menu-item>
            <nova-menu-item name="reverse-invoices" title="Reverse Invoices"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="credentialing" title="Credentialing" icon="school">
            <nova-menu-item name="autoassign" title="Auto Assign"></nova-menu-item>
            <nova-menu-item name="admin" title="Settings"></nova-menu-item>
            <nova-menu-item name="prestart-new" title="Pre-Start List"></nova-menu-item>
            <nova-menu-item name="workingList-new" title="Working List"></nova-menu-item>
            <nova-menu-item name="dashboard" path="candidates" title="Candidates"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="facility-contracts" title="Facility Contracts" icon="work">
            <nova-menu-item name="facilities" title="Facility Profiles (legacy)"></nova-menu-item>
            <nova-menu-item name="facility" title="Facilities"></nova-menu-item>
            <nova-menu-item name="accounts" title="Accounts"></nova-menu-item>
            <nova-menu-item name="account-search" path="accounts/search" title="Account Search" *ifLdFeature="flags.FacilityContractsAccountSearch"></nova-menu-item>
            <nova-menu-item name="agreements" title="Agreements" *ifLdFeature="flags.FacilityContractAgreements"></nova-menu-item>
            <nova-menu-item name="float-pools" title="Float Pools"></nova-menu-item>
            <nova-menu-item name="systems" title="Systems"></nova-menu-item>
            <nova-menu-item name="contract-groups" title="Contract Groups"></nova-menu-item>
            <nova-menu-item name="facility-groups" title="Facility Groups"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="leadqueue" title="Lead Queue" icon="how_to_reg">
            <nova-menu-item name="referrals" title="Referrals"></nova-menu-item>
            <nova-menu-item name="access" title="Access"></nova-menu-item>
            <nova-menu-item name="permissions-management" path="permissions-management" title="Permissions">
            </nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="clinical" title="Clinical" icon="local_hospital">
            <nova-menu-item name="review-queue" title="Review Queue"></nova-menu-item>
            <nova-menu-item name="staffing" title="Staffing Advisories"></nova-menu-item>
            <nova-menu-item name="contracts" title="Contracts"></nova-menu-item>
            <nova-menu-item name="ud-configuration" title="Job Req Configuration"></nova-menu-item>
            <nova-menu-item name="clinical-track-configuration" title="Clinical Track Configuration"></nova-menu-item>
            <nova-menu-item *ifLdFeature="flags.EnableClinicalSkillsManagement" name="clinical-skills-management" title="Skills Management"></nova-menu-item>
            <nova-menu-item *ifLdFeature="flags.EnableClinicalChecklistsConfiguration" name="clinical-assessment-configuration" title="Checklist Configuration" />
        </nova-menu-item>

        <nova-menu-item name="accountmanagers" title="Account Managers" defaultItem="active-candidates"
                        icon="how_to_reg">
            <nova-menu-item name="dashboard" title="Dashboard"></nova-menu-item>
            <nova-menu-item name="active-candidates" path="active-candidates" title="Candidates">
                <nova-menu-item name="pre-start-candidates" path="pre-start-candidates" title="Pre-Start Candidates">
                </nova-menu-item>
                <nova-menu-item name="working-candidates" path="working-candidates" title="Working Candidates">
                </nova-menu-item>
                <nova-menu-item name="permanent-candidates" path="permanent-candidates" title="Permanent Candidates">
                </nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="jobs" title="Jobs"></nova-menu-item>
            <nova-menu-item name="job-import" title="Job Import Queue" *ifLdFeature="flags.UseNewJobImporter">
                <nova-menu-item name="field-mapping" title="Field Mapping"></nova-menu-item>
                <nova-menu-item name="import-rules" title="Import Rules"></nova-menu-item>
                <nova-menu-item name="vendor-import-status" title="Vendor Import Status"></nova-menu-item>
                <nova-menu-item  path="job-import-reports" name="import-admin" title="Reporting"></nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="jobs-task" title="Jobs Task List"></nova-menu-item>
            <nova-menu-item name="submittals" title="Live List"></nova-menu-item>
            <nova-menu-item name="offers" title="Deals"></nova-menu-item>
            <nova-menu-item name="facilities" title="Facilities">
                <nova-menu-item name="workforce-disruption"
                                path="workforce-disruption" title="WFD Booked Candidates">
                </nova-menu-item>
            </nova-menu-item>
            <nova-menu-item name="am-ac-pairs" title="AM-AC Pairs"></nova-menu-item>
            <nova-menu-item name="work-order-confirmations" title="Work Order Confirmations"></nova-menu-item>
            <nova-menu-item name="physical-units" title="Physical Units/Depts" *ifLdFeature="flags.EnableNovaPhysicalUnitsCostCenters"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="workforce-solutions" title="Workforce Solutions" defaultItem="facilities"
                        icon="how_to_reg">
            <nova-menu-item name="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="facility-systems" title="Facility Systems"></nova-menu-item>
            <nova-menu-item name="jobs" title="Jobs"></nova-menu-item>
            <nova-menu-item name="active-candidates" path="active-candidates" title="Candidates">
                <nova-menu-item name="pre-start-candidates" path="pre-start-candidates" title="Pre-Start Candidates">
                </nova-menu-item>
                <nova-menu-item name="working-candidates" path="working-candidates" title="Working Candidates">
                </nova-menu-item>
            </nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="access-control" title="Access Control" icon="how_to_reg">
            <nova-menu-item name="candidates" title="Candidates"></nova-menu-item>
            <nova-menu-item name="badge-report" title="Badge Report"></nova-menu-item>
            <nova-menu-item name="manage-templates" title="Manage Templates"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="account-receivables" title="Accounts Receivable" icon="monetization_on">
            <nova-menu-item name="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="contracts" title="Contracts"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="partnernetwork" title="Partner Network" icon="flag" dataCy="PartnerNetworkMenuItem">
            <nova-menu-item name="candidate" title="Candidates"
                            dataCy="PartnerNetworkCandidatesSubMenuItem"></nova-menu-item>
            <nova-menu-item name="job" title="Jobs"></nova-menu-item>
            <nova-menu-item name="offers" title="Offers"></nova-menu-item>
            <nova-menu-item name="facility" title="Facilities"></nova-menu-item>
            <nova-menu-item name="margin" path="margin" title="Margins"></nova-menu-item>
            <nova-menu-item name="live-nurses" path="live-nurses" title="Live Nurses (new)"></nova-menu-item>
            <nova-menu-item name="auto-assign" path="auto-assign" title="Auto Assign"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="perdiem" title="Per Diem" icon="how_to_reg">
            <nova-menu-item name="shift-management" title="Shift Management"></nova-menu-item>
            <nova-menu-item name="nurse-availability" title="Nurse Availability"></nova-menu-item>
            <nova-menu-item name="perdiem-facilities" title="Per Diem Facilities"></nova-menu-item>
            <nova-menu-item name="perdiem-nurse-status" title="Nurse Status"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="perdiem-recruiting" title="Per Diem Recruiting" icon="how_to_reg">
            <nova-menu-item name="candidates" title="Candidates"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item *ifLdFeature="flags.NovaDisablePermRecruitingModule; enabled: false"
                        name="staff-recruiting" title="Permanent Recruiting" icon="person_pin_circle">
            <nova-menu-item name="candidates" title="Candidates"></nova-menu-item>
            <nova-menu-item name="jobs" title="Jobs"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="reporting" defaultItem="reports" title="Reporting" icon="insert_chart_outlined">
        </nova-menu-item>

        <nova-menu-item name="housing" title="Housing" icon="how_to_reg">
            <nova-menu-item name="housing-requests" title="Housing Requests"></nova-menu-item>
            <nova-menu-item name="leases" title="Leases"></nova-menu-item>
            <nova-menu-item name="vendors" title="Vendors"></nova-menu-item>
            <nova-menu-item name="properties" title="Properties"></nova-menu-item>
            <nova-menu-item name="vacate-notices" title="Vacate Notices"></nova-menu-item>
            <nova-menu-item name="market-pricing" title="Market Pricing Manager"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="commissions" title="Commissions" icon="face">
            <nova-menu-item name="facilities" title="Facilities"></nova-menu-item>
            <nova-menu-item name="search-contracts" title="Search Contracts"></nova-menu-item>
            <nova-menu-item name="commissions" title="Commissions"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="references" title="References" icon="how_to_reg">
            <nova-menu-item name="reference-requests" title="Reference Requests"></nova-menu-item>
        </nova-menu-item>

        <nova-menu-item name="martech" title="Martech" icon="how_to_reg">
            <nova-menu-item name="lead-scoring-control-panel" title="Engagement Scoring Control Panel"></nova-menu-item>
            <nova-menu-item name="facility-marketing-queue-view" title="Facility Overview Queue"></nova-menu-item>
        </nova-menu-item>

    </nova-nav-menu>

    <div class="app-content">
        <nova-top-nav-menu></nova-top-nav-menu>
        <div class="nova-main-content" version-checker>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
